import React from "react";
import { Phone, MapPin } from "lucide-react";
import { RESTAURANT } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[#16110E] text-[#F3EAD7] py-14">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left">
            <img
              src={`${process.env.PUBLIC_URL || ""}/logo.png`}
              alt="Uncle Willie's Southern Bistro"
              className="h-24 w-auto mx-auto md:mx-0"
            />
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-6 text-sm">
            <a
              href={RESTAURANT.directions}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-[#F0C766] transition-colors text-center sm:text-left"
            >
              <MapPin size={16} className="shrink-0" />
              <span className="flex flex-col sm:flex-row sm:items-center leading-tight">
                <span>
                  {RESTAURANT.address}
                  <span className="hidden sm:inline">,&nbsp;</span>
                </span>
                <span>{RESTAURANT.city}</span>
              </span>
            </a>
            <a
              href={RESTAURANT.phoneHref}
              className="flex items-center gap-2 hover:text-[#F0C766] transition-colors"
            >
              <Phone size={16} /> {RESTAURANT.phone}
            </a>
          </div>
        </div>

        <div className="border-t border-[#F3EAD7]/15 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="label-mono text-[#8A7C68]">
            © {new Date().getFullYear()} Uncle Willie's · Good Food. Good Friends. A Good Time.
          </p>
          <p className="label-mono text-[#8A7C68]">Quality · Presentation · Flavor</p>
        </div>

        <div className="mt-4 text-center">
          <p className="label-mono text-[#8A7C68] text-[11px]">
            Music: “Bossa Antigua” by Kevin MacLeod (incompetech.com) ·{" "}
            <a
              href="https://creativecommons.org/licenses/by/4.0/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#F0C766] transition-colors"
            >
              CC BY 4.0
            </a>
          </p>
        </div>

        <div className="border-t border-[#F3EAD7]/15 mt-6 pt-6 text-center">
          <p className="label-mono text-[#8A7C68]">
            Powered by{" "}
            <a
              href="https://techtronicsmedia.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#F0C766] hover:text-[#F3EAD7] transition-colors"
            >
              Techtronics Media
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
